import {useEffect, useState} from 'react'
import MainApiService from "../../services/api/MainApiService"
import {layoutConfig} from "../../configs/layout/layoutConfig"
import themeConfig from "../../configs/themeConfig"

const CompanyLogo = () => {

    const service = new MainApiService()
    const [logo, setLogo] = useState([])
    const layoutConf = layoutConfig()

    useEffect(() => {
        if (localStorage.getItem('appLogo') === null) {
            service
                .getCompanyLogo()
                .then(res => {
                    if (res.data !== null
                        && res.data !== undefined
                        && res.data !== '') {
                        setLogo(res.data.logo)
                        themeConfig.app.appName = res.data.appName
                        localStorage.setItem('appLogo', res.data.logo)
                        localStorage.setItem('appName', res.data.appName)
                        document.title = res.data.appName
                    } else {
                        setLogo(layoutConf.appLogo)
                        localStorage.setItem('appLogo', layoutConf.appLogo)
                        localStorage.setItem('appName', themeConfig.app.appName)
                        document.title = themeConfig.app.appName
                    }
                })
                .catch(() => {
                    console.error('Error while fetching api data. Reload the page.')
                })
        } else {
            setLogo(localStorage.getItem('appLogo'))
            document.title = localStorage.getItem('appName')
        }
    }, [])

    return (
        <img className='brand-logo-img' src={logo}/>
    )
}

export default CompanyLogo